import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import TabsLayout from '../components/TabsLayout';
import OffersList from './tabs-contents/OffersList';
import stepsTabs from '../config/tabs';
import {getCurrentTabIndex} from '../utils/routingHelpers';
import {sortingOptions} from './offers/offersSort';
import {
  checkOfferStatus,
  getAllOffers,
  updateCustomerSelectedOffer,
  updateNoOffers,
} from '../utils/apiHandlers';
import {
  getDetailForm,
  getOffersFields,
  getUtmFields,
  setDetailForm,
  setOffersFields,
  setSelectedOffer,
} from '../utils/persistOfferDetails';
import {fireGtmEvent} from '../utils/marketing.utils';
import {FORMIK_DEBOUNCE} from '../utils/formik-persist';
import {Form, Formik} from 'formik';
import ValidationSchema from './tabs-contents/initial-details/helpers/Tab4_helpers/validationSchema';
import * as yup from 'yup';
import ApprovalDisclaimerModal from '../components/modals/ApprovalDisclaimer';
import {findApprovalDisclaimerForOffer} from '../config/approvalDisclaimers';

// import Offers from "../config/mock.offers";

const tabs = stepsTabs().offers;

const CHECK_STATUS_TIMEOUT = process.env.REACT_APP_CHECK_STATUS_TIMEOUT || 2000;
const CHECK_STATUS_TIME_LIMIT =
  process.env.REACT_APP_CHECK_STATUS_TIME_LIMIT || 20000;

class OffersPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.setTab = this.setTab.bind(this);
    this.handler = this.handler.bind(this);
    this.checkStatus = this.checkStatus.bind(this);
    this.getOffers = this.getOffers.bind(this);
    this.handleSelectedOffer = this.handleSelectedOffer.bind(this);
    this.handleNoOffers = this.handleNoOffers.bind(this);

    this.state = {
      offers: [],
      offersCallId: '',
      keepChecking: true,
      loader: true,
      lowestPrice: 0,
      sortTypeId: 1,
      isSubmitting: false,
      // Approval disclaimer modal state
      approvalModalOpen: false,
      activeApprovalDisclaimer: null,
      pendingOffer: null,
    };
  }

  async handler(actionType, values) {
    switch (actionType) {
    case 'sort': {
      const sortTypeId = values;
      const comparer = sortingOptions.find(
        (sortingOption) => sortingOption.id === sortTypeId,
      ).comparer;
      this.setState({
        sortTypeId,
        offers: [...this.state.offers.sort(comparer)],
      });
      break;
    }
    }
  }

  checkStatus() {
    checkOfferStatus({
      offersCallId: this.state.offersCallId,
    }).then((resp) => {
      if (resp.data && resp.data.responses && resp.data.responses.length) {
        const respOffers = resp.data.responses;
        this.setState(
          {
            offers: respOffers,
            lowestPrice: respOffers.reduce(
              (lowestPrice, {price}) => !lowestPrice ?
									price :
									price < lowestPrice ?
									price :
									lowestPrice,
              0,
            ),
          },
          () => {
            this.handler('sort', this.state.sortTypeId);
          },
        );
      }
    });
  }

  initTimer() {
    const that = this;
    this.setState({keepChecking: true,
      loader: true}, () => {
      this.statusInterval = setInterval(() => {
        if (that.state.keepChecking) {
          that.checkStatus();
        } else {
          that.setState({keepChecking: false,
            loader: false});
          clearInterval(that.statusInterval);
        }
      }, CHECK_STATUS_TIMEOUT);

      this.timeout = setTimeout(() => {
        that.setState({
          keepChecking: false,
          loader: false,
        });
        clearInterval(that.statusInterval);
      }, CHECK_STATUS_TIME_LIMIT);
    });
  }

  getOffers() {
    const requestData = JSON.parse(
      sessionStorage.getItem('travel.details-form'),
    ).values;
    sessionStorage.setItem('prevFormDetails', JSON.stringify(requestData));
    requestData.agentDeveloperName = getOffersFields('agentDeveloperName');
    requestData.utmFields = getUtmFields();
    if (sessionStorage.getItem('leadId')) {
      requestData.leadId = sessionStorage.getItem('leadId');
    }
    if (sessionStorage.getItem('parentLeadId')) {
      requestData.parentLeadId = sessionStorage.getItem('parentLeadId');
    }
    this.setState(
      {
        offers: [],
        keepChecking: true,
      },
      () => {
        getAllOffers(requestData)
          .then((resp) => {
            if (resp.data) {
              const offerCallIdState = {offersCallId: resp.data.offersCallId};
              const leadId = resp.data.leadId;
              setOffersFields(offerCallIdState);
              sessionStorage.setItem('leadId', leadId);
              this.setState(offerCallIdState);
            }
            this.initTimer();
          })
          .catch(() => {
            this.setState({keepChecking: false});
          });
      },
    );
  }

  componentDidMount() {
    this.setTab(this.props.location);

    // set minimal delay so that formik-persist has time to save form values to session storage
    setTimeout(this.getOffers, FORMIK_DEBOUNCE + 10);
    this.unlisten = this.props.history.listen((location) => {
      this.setTab(location);
    });
  }

	handleUpdateRiders = async (values, validateForm) => {
	  const errors = await validateForm(); // Trigger validation manually
	  if (Object.keys(errors).length === 0) {
	    // No errors, proceed with the logic
	    this.setState({
	      keepChecking: true,
	      loader: true,
	    });
	    this.getOffers();
      this.initTimer();
	  } else {
	    // Handle errors (e.g., show a message or log them)
	    console.error('Validation errors:', errors);
	  }
	};

	clearInsuranceCoversWarning = (data) => data.insuranceCovers.filter((cover) => cover.warning !== true);

	handleSelectedOffer = async (data) => {
	  data.insuranceCovers = this.clearInsuranceCoversWarning(data);
	  if (sessionStorage.getItem('leadId')) {
	    data.leadId = sessionStorage.getItem('leadId');
	  }

	  setSelectedOffer(data);
	  const resp = await updateCustomerSelectedOffer({
	    selectedOffer: data,
	    token: this.state.offersCallId,
	  });
	  return Boolean(resp.success);
	};

	// Made indiction there no have offers to the user
	handleNoOffers = () => {
	  updateNoOffers({
	    token: this.state.offersCallId,
	  });
	};

	// Check if an approval disclaimer is required for this offer
	checkApprovalDisclaimer = (offerIndex) => {
	  const offer = this.state.offers[offerIndex];
	  const detailForm = getDetailForm();
	  const targetCountries = detailForm?.values?.targetCountries || [];
	  
	  const disclaimer = findApprovalDisclaimerForOffer(offer.provider, targetCountries);
	  return disclaimer;
	};

	// Handle approval disclaimer confirmation
	handleApprovalConfirm = async () => {
	  const {pendingOffer} = this.state;
	  this.setState({
	    approvalModalOpen: false,
	    activeApprovalDisclaimer: null,
	    pendingOffer: null,
	  });
	  
	  if (pendingOffer !== null) {
	    await this.proceedWithOffer(pendingOffer);
	  }
	};

	// Handle approval disclaimer dismissal
	handleApprovalDismiss = () => {
	  this.setState({
	    approvalModalOpen: false,
	    activeApprovalDisclaimer: null,
	    pendingOffer: null,
	  });
	};

	// Proceed with offer selection (called after approval or when no approval needed)
	proceedWithOffer = async (offer) => {
	  this.setState({isSubmitting: true});
	  sessionStorage.setItem(
	    'travel.offerSelected',
	    JSON.stringify(offer),
	  );
	  sessionStorage.setItem(
	    'travel.offersCallId',
	    JSON.stringify(this.state.offersCallId),
	  );
	  fireGtmEvent('travelPurchase', {provider: offer});
	  const response = await this.handleSelectedOffer(offer);
	  this.setState({isSubmitting: false});
	  if (response) {
	    this.props.history.push('complete-details');
	  } else {
	    this.setState({isErrorOpen: true});
	  }
	};

	submit = async (offerIndex) => {
	  const offer = this.state.offers[offerIndex];
	  
	  // Check if approval disclaimer is required
	  const disclaimer = this.checkApprovalDisclaimer(offerIndex);
	  
	  if (disclaimer) {
	    // Show approval modal and wait for confirmation
	    // Store the offer object itself (not index) to avoid issues with offers array changing
	    this.setState({
	      approvalModalOpen: true,
	      activeApprovalDisclaimer: disclaimer,
	      pendingOffer: offer,
	    });
	    return;
	  }
	  
	  // No approval needed, proceed directly
	  await this.proceedWithOffer(offer);
	};

	setTab(location) {
	  const tabIndex = getCurrentTabIndex(location, 'offers');
	  if (tabIndex === false) {
	    return;
	  }
	  sessionStorage.setItem('travel.offers-tab', tabIndex);
	}

	componentWillUnmount() {
	  this.unlisten();
	}

	handleFormikChange = (updatedValues) => {
	  setDetailForm({values: updatedValues});
	};

	render() {
	  this.props.changeSideBar(false);
	  return (
	    <>
	      <Formik
	        validationSchema={yup.object().shape(ValidationSchema)}
	        initialValues={getDetailForm().values}
	        validateOnChange={false} // Disable validation on change
	        validateOnBlur={false} // Disable validation on blur
	      >
	        {({
	          values,
	          errors,
	          setFieldValue,
	          setFieldError, // Add setFieldError to clear specific field errors
	          validateForm,
	        }) => {
	          // Wrap setFieldValue to call handleFormikChange and clear field errors
	          const customSetFieldValue = (field, value) => {
	            setFieldValue(field, value); // Update the Formik state
	            setFieldError(field, undefined); // Clear the error for the field
	            this.handleFormikChange({...values,
	              [field]: value}); // Call your custom handler
	          };

	          return (
	            <Form>
	              <TabsLayout
	                isTabsContainer={false}
	                tabs={tabs}
	                currentTabIndex={Number(
	                  sessionStorage.getItem('travel.offers-tab'),
	                )}
	                formikSetField={customSetFieldValue} // Pass the wrapped function
	                formikErrors={errors}
	                formikValues={values}
	                validateForm={validateForm}
	                setFieldError={setFieldError}
	              >
	                <OffersList
	                  formikErrors={errors}
	                  formikValues={values}
	                  formikSetField={customSetFieldValue}
	                  validateForm={validateForm}
	                  offers={this.state.offers}
	                  loaderState={this.state.loader}
	                  keepChecking={this.state.keepChecking}
	                  submitAct={(offerIndex) => this.submit(offerIndex)}
	                  isSubmitting={this.state.isSubmitting}
	                  isErrorOpen={this.state.isErrorOpen}
	                  handleNoOffers={this.handleNoOffers}
	                  handleErrorClose={() => this.setState({isErrorOpen: false})}
	                  handleUpdateRiders={() => this.handleUpdateRiders(values, validateForm)
	                  }
	                />
	              </TabsLayout>
	            </Form>
	          );
	        }}
	      </Formik>
	      
	      <ApprovalDisclaimerModal
	        open={this.state.approvalModalOpen}
	        onConfirm={this.handleApprovalConfirm}
	        onDismiss={this.handleApprovalDismiss}
	        disclaimerConfig={this.state.activeApprovalDisclaimer}
	      />
	    </>
	  );
	}
}

OffersPage.propTypes = {
  location: PropTypes.any,
  changeSideBar: PropTypes.bool,
  history: PropTypes.any,
};

export default withRouter(OffersPage);
